import { useEffect, useState } from 'react';
import { HosApiDashboardMenuCheckouts } from '../../types/apiTypes';
import { DashboardCardTimespan, DashboardData } from '../../types/commonTypes';
import { useFetch } from '../useFetch';
import { useOperator } from '../../contexts/OperatorContext';
import { BASE_URL_MAP } from '../../lib/environment';

export const useMenuCheckouts = () => {
  const [menuCheckouts, setMenuCheckouts] = useState<DashboardData[]>([]);
  const { makeRequest, loading, response } = useFetch();
  const operator = useOperator();

  useEffect(() => {
    if (response) setMenuCheckouts(mapMenuCheckout(response));
  }, [response]);

  const getMenuCheckouts = (dateRange?: DashboardCardTimespan) => {
    let url = `${BASE_URL_MAP['Hospitality']}/${operator?.id}/Dashboard/Checkouts`;
    if (dateRange)
      url += `?startDate=${dateRange.startDate.toISOString()}&endDate=${dateRange.endDate.toISOString()}`;

    makeRequest(url, 'get');
  };

  return { menuCheckouts, getMenuCheckouts, loading };
};

const mapMenuCheckout = (
  menuCheckout: HosApiDashboardMenuCheckouts
): DashboardData[] => {
  return [
    {
      id: 'Express Checkout',
      value: menuCheckout.NumberOfCheckouts,
    },
    {
      id: 'Late Checkout',
      value: menuCheckout.NumberOfLateCheckouts,
    },
  ];
};
